import styles from "./keyfobtabs.module.css";
import { Plus, Trash2, ChevronDown } from "react-feather";
import LockCard from "./LockCard";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Dropdown } from "react-bootstrap";

const KeyfobTabs = ({ lockList, setAddLockPopup, setDeleteModalOpen, setDeleteCardId, setmDeleteModalOpen, setmDeleteCardId, mdeleteCardId }) => {

    return <div className={`${styles.SMProCusBigDiv}`}>
        <div className={`${styles.card}`}>
            <div className={`${styles.cardbody}`}>
                <div className={`${styles.SMBigSideBody} TabMainClientProfile ClientDetails`}>
                    <div>
                        <div className={`${styles.ManageLockHead}`}>
                            <h5 className={`${styles.Title}`}>Manage Locks</h5>
                            {/*<div className={`${styles.MainReqConDropBU}`}>
                                <Dropdown>
                                    <Dropdown.Toggle id="dropdown-basic" className={`${styles.ReferStatusBU} ${styles.Resolved}`}>
                                    Active
                                    <ChevronDown className={`${styles.DownArrowStatus}`}/>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="DropDownMenuBoxCus">
                                    <Dropdown.Item className="DropDListWIcon" href="">Active</Dropdown.Item>
                                    <Dropdown.Item className="DropDListWIcon" href="">Disabled</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>*/}
                            <button className={`${styles.AddLockBU}`} onClick={(e) => setAddLockPopup(true)}><Plus /> Lock</button>
                        </div>
                        <div className={`${styles.AlertsRow}`}>
                            <div className={`${styles.AlertMainCheckSec}`}>
                                <FormControlLabel className="CustomCheck"
                                    control={
                                        <Checkbox
                                            indeterminate={mdeleteCardId?.length > 0 && lockList?.length !== mdeleteCardId?.length}
                                            checked={mdeleteCardId?.length > 0 && lockList?.length === mdeleteCardId?.length}
                                            onChange={(e) => {
                                                let selectedTemp = [];
                                                if (e.target.checked) {
                                                    selectedTemp = lockList?.map(i => parseInt(i?.id))
                                                }

                                                setmDeleteCardId(selectedTemp);
                                            }}
                                        />
                                    }
                                    label="Select All Locks"
                                />
                                {mdeleteCardId?.length > 0 && <button className={`${styles.AlertDeleteBU}`} onClick={(e) => setmDeleteModalOpen(true)}>
                                    <Trash2 /> Delete {mdeleteCardId.length} Lock(s)
                                </button>}
                            </div>
                            <div className={`${styles.NotesRow}`}>

                                {lockList?.map(item => {
                                    return <LockCard item={item} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setDeleteCardId={setDeleteCardId.bind(this)} setmDeleteCardId={setmDeleteCardId.bind(this)} mdeleteCardId={mdeleteCardId} />
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default KeyfobTabs;